export enum TipoActivoPrecio {
  Inactivo = 0,
  Activo = 1,
  PendienteDesactivacion = 2 
  
}
